import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";

const Nav = () => {
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [menuOpen]);

  const navGroups = [
    {
      title: "資料科學、人工智能AI",
      links: [
        { path: "/dl", label: "深度學習" },
        { path: "/ml", label: "機器學習" },
        { path: "/python", label: "Python" },
        { path: "/linearAlgebra", label: "線性代數" },
      ],
    },
    {
      title: "數學與邏輯（面試必備）",
      links: [
        { path: "/discrete", label: "離散數學" },
        { path: "/crypto", label: "數論與密碼學" },
        { path: "/dataStructure", label: "資料結構與演算法" },
        { path: "/linearAlgebra", label: "線性代數" },
      ],
    },
    {
      title: "程式語言、全端、軟體開發",
      links: [
        { path: "/python", label: "Python" },
        { path: "/webdev", label: "網頁開發" },
        { path: "/java", label: "Java" },
        { path: "/android", label: "Android" },
      ],
    },

    {
      title: "其他",
      links: [{ path: "/info", label: "其他資訊" }],
    },
  ];

  return (
    <nav className={menuOpen ? "nav open" : "nav"}>
      {/* 直接將 toggle 狀態綁定在 burger 上 */}
      <div
        className={`burger ${menuOpen ? "lineColor" : ""}`}
        onClick={toggleMenu}
      >
        <div className="line line1"></div>
        <div className="line line2"></div>
        <div className="line line3"></div>
      </div>

      <div className={`nav-groups ${menuOpen ? "show" : ""}`}>
        <div className="home-group">
          <div className="link-wrapper home-link">
            <Link to="/" onClick={closeMenu}>
              <span className="logo-text">Wilson Ren</span>
              <span className="divider">|</span>
              <span className="home-text">首頁</span>
            </Link>

            <motion.div
              className="bar"
              transition={{ duration: 0.3 }}
              initial={{ width: 0 }}
              animate={{
                width: pathname === "/" ? "100%" : "0%",
              }}
            />
          </div>
        </div>

        <div className="courses-area">
          {navGroups.map((group) => (
            <div className="nav-group" key={group.title}>
              <h3>{group.title}</h3>

              <div className="group-links">
                {group.links.map((link) => (
                  <div
                    className="link-wrapper"
                    key={`${group.title}-${link.path}`}
                  >
                    <Link to={link.path} onClick={closeMenu}>
                      {link.label}
                    </Link>

                    <motion.div
                      className="bar"
                      transition={{ duration: 0.3 }}
                      initial={{ width: 0 }}
                      animate={{
                        width: pathname === link.path ? "100%" : "0%",
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Nav;
